<template>
  <div class="user_info">
    <el-card>
      <div class="user_info_title">
        <span></span>
        基本信息
      </div>
      <div class="user_info_body">
        <div class="user_info_body_left">
          <el-image v-if="userData.userAvatarKey" :src="userData.userAvatarKey" />
          <el-image v-else-if="userData.sex === '男'" :src="require('@/assets/images/man.png')" />
          <el-image v-else-if="userData.sex === '女'" :src="require('@/assets/images/woman.png')" />
          <span v-if="userData.isOffice">在职</span>
          <span v-else>已离职</span>
        </div>
        <div class="user_info_body_center">
          <div class="user_info_body_center_li">
            <span>ID：</span>
            <span>{{ userData.id }}</span>
          </div>
          <div class="user_info_body_center_li">
            <span>用户名：</span>
            <span>{{ userData.userName }}</span>
          </div>
          <div class="user_info_body_center_li">
            <span>性别：</span>
            <span>{{ userData.sex }}</span>
          </div>
          <div class="user_info_body_center_li">
            <span>电话：</span>
            <span>{{ userData.mobile }}</span>
          </div>
          <div class="user_info_body_center_li">
            <span>邮箱：</span>
            <span>{{ userData.email }}</span>
          </div>
          <div class="user_info_body_center_li">
            <span>微信：</span>
            <span>{{ userData.weChat }}</span>
          </div>
          <div class="user_info_body_center_li">
            <span>入职时间：</span>
            <span>{{ userData.entryTime }}</span>
          </div>
        </div>
        <div class="user_info_body_right">
          <p>创建时间：{{ userData.createTime }}</p>
          <p>最后登录时间：{{ userData.updateTime }}</p>
        </div>
      </div>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="user_info_title margin24">
        <span></span>
        关联项目
      </div>
      <div class="table_data">
        <el-table
          :data="tableData"
          style="width: 100%; margin-top: 20px"
          border
          :header-cell-style="{
            'background-color': '#F1F1F1'
          }"
        >
          <el-table-column label="项目所属公司" prop="corporateName" align="center" />
          <el-table-column label="项目岗位" prop="recruitmentPosition" align="center" />
          <el-table-column label="项目编号" prop="itemNo" align="center" />
          <el-table-column label="项目状态" prop="projectPhase" align="center" />
          <!-- <el-table-column label="所处职位" align="center" /> -->
          <el-table-column label="操作" align="center">
            <template v-slot="{ row }">
              <el-button type="text" @click="viewClick(row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>
  </div>
</template>

<script>
import { detailId, listProject } from '@/api/user.js'
export default {
  name: 'userInforMation',
  data() {
    return {
      tableData: [], //表格数据
      userData: {
        id: '', //主键id
        email: '', //邮件
        entryTime: '', //入职时间
        isOffice: true, //是否在职
        isStop: true, //是否启用
        mobile: '', //手机号
        password: '', //密码
        roleId: '', //角色id
        roleName: '', //角色名字
        sex: '', //性别
        userAvatar: '', //头像文件
        userAvatarKey: '', //头像
        userName: '', //用户名
        weChat: '', //微信名
        updateTime: '', //最后登录时间
        createTime: '' //创建时间
      }
    }
  },
  created() {
    this.search()
  },
  computed: {
    //用户id
    id() {
      return this.$route.query.id
    }
  },
  methods: {
    //详情点击
    viewClick(row) {
      this.$router.push({
        name: 'ViewProject',
        query: {
          id: row.id
        }
      })
    },
    //关联的项目
    async proOne() {
      const { data: res } = await listProject({ consultant: this.userData.userName })
      if (res.resultCode === 200) {
        this.tableData = res.data
      }
    },
    //根据id查看用户详情
    async search() {
      const { data: res } = await detailId({ id: this.id })
      if (res.resultCode === 200) {
        this.userData = res.data
        this.proOne()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.user_info {
  width: 100%;

  /deep/.el-card__body {
    padding: 0;
  }

  .table_data {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 20px 120px;
  }

  .user_info_title {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 16px;
    height: 50px;
    display: flex;
    align-items: center;
    font-size: 14px;
    border-bottom: 1px solid #e5e5e5;
    font-weight: 500;
    color: #1a1f33;

    span {
      width: 6px;
      height: 20px;
      margin-right: 8px;
      display: block;
      background-color: #17757a;
      border-radius: 4px;
    }
  }

  .user_info_body {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 40px;
    display: flex;
    justify-content: space-between;

    .user_info_body_left {
      min-width: 80px;
      margin-right: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;

      /deep/ .el-image {
        width: 80px;
        height: 80px;
        display: block;
        border-radius: 50%;
        margin-bottom: 12px;
      }
    }

    .user_info_body_center {
      display: flex;
      flex-flow: row wrap;
      .user_info_body_center_li {
        min-width: 30%;
        display: flex;
        align-content: center;
        margin-right: 20px;
        font-size: 14px;
        margin-bottom: 20px;
        color: #333;

        span {
          display: block;
          font-weight: 500;
          color: #1a1f33;
        }
      }
    }

    .user_info_body_right {
      display: flex;
      flex-direction: column;
      justify-content: flex-end;

      p {
        color: #808080;
        font-size: 12px;
      }
    }
  }
}
</style>
